module.exports = __webpack_public_path__ + "img/8.387bef91.png";